import React from 'react';
import { PenToolIcon } from 'lucide-react';
import { CreativeDirectoryPage, CreativeArtist } from '../../components/creative/CreativeDirectoryPage';
const artists: CreativeArtist[] = [{
  id: '1',
  name: 'Sarah Chen',
  title: 'Book Cover Designer',
  specialties: ['Fantasy Covers', 'Typography', 'Digital Illustration'],
  rating: 4.9,
  reviewCount: 156,
  imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$300-800'
}, {
  id: '2',
  name: 'Marcus Rodriguez',
  title: 'Cover Art Specialist',
  specialties: ['Romance', 'Contemporary', 'Photo Manipulation'],
  rating: 4.8,
  reviewCount: 112,
  imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=256&q=80',
  available: true,
  priceRange: '$250-600'
}];
const CoverArtists = () => <CreativeDirectoryPage title="Cover Artists" subtitle="Connect with professional cover designers to create stunning book covers that capture readers' attention" icon={<PenToolIcon className="h-8 w-8" data-id="element-9282" data-mp="6pc2pgxb2eox" />} profileBasePath="/creative/cover-artists" artists={artists} data-id="element-9281" data-mp="hxf0gqtumb5h" />;
export default CoverArtists;